import React from 'react';
import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
} from '../../ui/alert-dialog';

interface EditCompletedReportDialogProps {
    open: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

export function EditCompletedReportDialog({
    open,
    onConfirm,
    onCancel,
}: EditCompletedReportDialogProps) {
    return (
        <AlertDialog open={open} onOpenChange={(o) => !o && onCancel()}>
            <AlertDialogContent>
                <AlertDialogHeader>
                    <AlertDialogTitle>
                        Edit Completed Report
                    </AlertDialogTitle>
                    <AlertDialogDescription>
                        This case has already been completed. Editing will
                        require the report to be re-completed. Are you sure
                        you want to continue?
                    </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <AlertDialogCancel>Cancel</AlertDialogCancel>
                    <AlertDialogAction onClick={onConfirm}>
                        Edit Document
                    </AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
}
